<template>
    <a
        ref="icon"
        v-if="activePanel"
        class="header-icon"
        href="#"
        :title="titlePanel"
        data-toggle="tooltip-city"
        @click.prevent="togglePanel">
        <i class="far fa-bell"></i>
        <span class="badge badge-icon" v-if="number>0">
            {{ number }}
        </span>
    </a>
</template>

<script>
    import ComponentMixin from '../mixins/ComponentMixin';

    export default {
        name: "activityHeaderTool",
        mixins: [
            ComponentMixin,
        ],
        props: {
            propIdPanel: {
                type: String,
                default: 'activity'
            },
        },
        data() {
            return {
                idPanel: this.propIdPanel,
            }
        },
        computed: {
            summary() {
                return this.panel.summary;
            },
            number() {
                let item = this.summary.find( item => item.titleTemplate);
                return item ? item.num : 0;
            },
            titlePanel() {
                let item = this.summary.find( item => item.titleTemplate);
                if(item && item.num>0){
                    return this.$t(item.titleTemplate, {number: item.num});
                }
                return this.title;
            },
        },
        watch: {
            number: {
                handler: function(newValue, oldValue) {
                    let ref = this.$refs.icon;
                    if(ref) {
                        ref.setAttribute('data-original-title', this.titlePanel);
                    }
                }
            }
        }
    };
</script>